<bdeo-card>
  <div class="card-skeleton">
    <div class="card-skeleton__header">
      <div class="card-skeleton__date">
        <bdeo-skeleton-body-text margin="true"></bdeo-skeleton-body-text>
        <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
      </div>
      <bdeo-skeleton-title-text class="card-skeleton__tag" size="medium"></bdeo-skeleton-title-text>
    </div>

    <div class="card-skeleton__fields">
      <div class="card-skeleton__fields-label">
        <bdeo-skeleton-body-text margin="true"></bdeo-skeleton-body-text>
        <bdeo-skeleton-body-text margin="true"></bdeo-skeleton-body-text>
        <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
      </div>
      <div class="card-skeleton__fields-value">
        <bdeo-skeleton-body-text margin="true"></bdeo-skeleton-body-text>
        <bdeo-skeleton-body-text margin="true"></bdeo-skeleton-body-text>
        <bdeo-skeleton-body-text></bdeo-skeleton-body-text>
      </div>
    </div>
  </div>
</bdeo-card>
